// UI Hit Test utilities - pointer-based element detection

/**
 * Get the last tracked pointer position
 * Uses the global pointer event tracker set up by the Game component
 * 
 * @returns {{ clientX: number, clientY: number }|null} Last pointer event or null
 */
export function getLastPointerEvent() {
  return window._gc_last_pointer_event || null;
}

/**
 * Check if a point is within an element's bounding rect
 * 
 * @param {number} x - Client X coordinate
 * @param {number} y - Client Y coordinate
 * @param {DOMRect} rect - Element bounding rect
 * @returns {boolean} True if point is within rect
 */
export function isPointInRect(x, y, rect) {
  return x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
}

/**
 * Test which augment dock slot the pointer is over
 * 
 * @returns {number|null} Slot index (0-based) or null if not over any slot
 */
export function hitTestAugmentDock() {
  try {
    const lastEvent = getLastPointerEvent();
    if (!lastEvent) return null;
    const x = lastEvent.clientX;
    const y = lastEvent.clientY;
    const cards = document.querySelectorAll('[data-augslot-index]');
    for (let i = 0; i < cards.length; i++) {
      const el = cards[i];
      const r = el.getBoundingClientRect();
      if (isPointInRect(x, y, r)) {
        const idx = parseInt(el.getAttribute('data-augslot-index') || '-1', 10);
        return isNaN(idx) ? null : idx;
      }
    }
    return null;
  } catch (_) {
    return null;
  }
}

/**
 * Test if the pointer is over the sell panel
 * 
 * @returns {boolean} True if pointer is over sell panel
 */
export function hitTestSellPanel() {
  try {
    const lastEvent = getLastPointerEvent();
    if (!lastEvent) return false;
    const el = document.querySelector('[data-sell-panel]');
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return isPointInRect(lastEvent.clientX, lastEvent.clientY, r);
  } catch (_) {
    return false;
  }
}

/**
 * Test if the pointer is within a specific element
 * 
 * @param {string} selector - CSS selector for the element
 * @returns {boolean} True if pointer is over the element
 */
export function hitTestElement(selector) {
  try {
    const lastEvent = getLastPointerEvent();
    if (!lastEvent) return false;
    const el = document.querySelector(selector);
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return isPointInRect(lastEvent.clientX, lastEvent.clientY, r);
  } catch (_) {
    return false;
  }
}






